"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[708],{

/***/ 46293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ SvgArrowQuestion; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.03107 1.02925C0.030905 1.29372 0.13229 1.55846 0.33482 1.75965L5.30622 6.70085C5.70736 7.09944 6.35474 7.09944 6.75587 6.70085L11.7273 1.75965C12.1302 1.35909 12.1325 0.707232 11.7323 0.303939C11.332 -0.099618 10.6807 -0.10184 10.2776 0.298857L6.03096 4.51957L1.78437 0.298857C1.38133 -0.10184 0.730025 -0.099618 0.329735 0.303939C0.13055 0.504612 0.03107 0.766995 0.03107 1.02925Z",
  fill: "#A8A8A8"
});

function SvgArrowQuestion({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEzIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC4wMzEwNyAxLjAyOTI1QzAuMDMwOTA1IDEuMjkzNzIgMC4xMzIyOSAxLjU1ODQ2IDAuMzM0ODIgMS43NTk2NUw1LjMwNjIyIDYuNzAwODVDNS43MDczNiA3LjA5OTQ0IDYuMzU0NzQgNy4wOTk0NCA2Ljc1NTg3IDYuNzAwODVMMTEuNzI3MyAxLjc1OTY1QzEyLjEzMDIgMS4zNTkwOSAxMi4xMzI1IDAuNzA3MjMyIDExLjczMjMgMC4zMDM5MzlDMTEuMzMyIC0wLjA5OTYxOCAxMC42ODA3IC0wLjEwMTg0IDEwLjI3NzYgMC4yOTg4NTdMNi4wMzA5NiA0LjUxOTU3TDEuNzg0MzcgMC4yOTg4NTdDMS4zODEzMyAtMC4xMDE4NCAwLjczMDAyNSAtMC4wOTk2MTggMC4zMjk3MzUgMC4zMDM5MzlDMC4xMzA1NSAwLjUwNDYxMiAwLjAzMTA3IDAuNzY2OTk1IDAuMDMxMDcgMS4wMjkyNVoiIGZpbGw9IiNBOEE4QTgiLz4KPC9zdmc+Cg==");


/***/ }),

/***/ 27212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BlogSharedHeader_BlogSharedHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/production/index.js
var production = __webpack_require__(1617);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@tager/web-core/dist/web-core.esm.js + 6 modules
var web_core_esm = __webpack_require__(61055);
// EXTERNAL MODULE: ./src/assets/svg/arrow_question.svg
var arrow_question = __webpack_require__(46293);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/DropDown/DropDown.tsx








function DropDown({
  title,
  children,
  className,
  activeTab
}) {
  const {
    0: isOpen,
    1: setOpen
  } = (0,react.useState)(false);
  const {
    0: height,
    1: setHeight
  } = (0,react.useState)(0);
  const ref = (0,react.useRef)(null);

  const opener = () => {
    setOpen(prev => !prev);
  };

  (0,react.useEffect)(() => {
    if ((0,web_core_esm.isBrowser)() && ref.current) {
      setHeight(ref.current.scrollHeight);
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Component, {
    className: className,
    active: isOpen,
    onClick: opener,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Top, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        className: `dropdown-title text-element_${activeTab === title ? 'highlighted' : 'hide'}`,
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, {
        className: "dropdown-arrow"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContentWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Content, {
        ref: ref,
        active: isOpen,
        size: height,
        children: children
      })
    })]
  });
}

/* harmony default export */ var DropDown_DropDown = (DropDown);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DropDown__Component",
  componentId: "sc-10hclwr-0"
})(["cursor:pointer;& svg{transition:transform 0.2s ease;}", ""], ({
  active
}) => active && (0,styled_components_browser_esm.css)(["& .text-element_highlighted{color:", ";}& .dropdown-arrow{transform:rotate(-180deg);}& .dropdown-arrow path{fill:", ";}"], theme/* colors.primary */.O9.primary, theme/* colors.primary */.O9.primary));
const Title = styled_components_browser_esm["default"].span.withConfig({
  displayName: "DropDown__Title",
  componentId: "sc-10hclwr-1"
})(["font-style:normal;font-weight:500;font-size:13px;line-height:30px;"]);
const Top = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DropDown__Top",
  componentId: "sc-10hclwr-2"
})(["display:flex;align-items:center;justify-content:space-between;"]);
const ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DropDown__ContentWrapper",
  componentId: "sc-10hclwr-3"
})(["overflow:hidden;"]);
const Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DropDown__Content",
  componentId: "sc-10hclwr-4"
})(["transition:height 0.2s ease;", ""], ({
  active,
  size
}) => active ? (0,styled_components_browser_esm.css)(["height:", "px;"], size) : (0,styled_components_browser_esm.css)(["height:0;margin-top:0;"]));
const StyledIcon = (0,styled_components_browser_esm["default"])(arrow_question/* ReactComponent */.r).withConfig({
  displayName: "DropDown__StyledIcon",
  componentId: "sc-10hclwr-5"
})([""]);
;// CONCATENATED MODULE: ./src/components/DropDown/index.ts

;// CONCATENATED MODULE: ./src/assets/svg/book.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 -0.000366211H2.00003C0.900048 -0.000366211 0 0.899702 0 1.99963V12.9996C0 14.6497 1.35007 15.9996 3.00006 15.9996H12C13.1 15.9996 14 15.0997 14 13.9996V1.99963C14 0.899702 13.1 -0.000366211 12 -0.000366211ZM12 13.9996H5.81997H3.00006C2.45007 13.9996 2.00003 13.5497 2.00003 12.9996C2.00003 12.4496 2.45007 11.9996 3.00006 11.9996H5.81997H12V13.9996ZM12 9.99958H3.00006C2.65001 9.99958 2.30996 10.0595 2.00003 10.1795V9.99958V1.99963H6.99999V6.99967L8.99995 5.99955L11.0001 6.99967V1.99963H12V9.99958Z",
  fill: "#860935"
});

function SvgBook({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* harmony default export */ var book = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAtMC4wMDAzNjYyMTFIMi4wMDAwM0MwLjkwMDA0OCAtMC4wMDAzNjYyMTEgMCAwLjg5OTcwMiAwIDEuOTk5NjNWMTIuOTk5NkMwIDE0LjY0OTcgMS4zNTAwNyAxNS45OTk2IDMuMDAwMDYgMTUuOTk5NkgxMkMxMy4xIDE1Ljk5OTYgMTQgMTUuMDk5NyAxNCAxMy45OTk2VjEuOTk5NjNDMTQgMC44OTk3MDIgMTMuMSAtMC4wMDAzNjYyMTEgMTIgLTAuMDAwMzY2MjExWk0xMiAxMy45OTk2SDUuODE5OTdIMy4wMDAwNkMyLjQ1MDA3IDEzLjk5OTYgMi4wMDAwMyAxMy41NDk3IDIuMDAwMDMgMTIuOTk5NkMyLjAwMDAzIDEyLjQ0OTYgMi40NTAwNyAxMS45OTk2IDMuMDAwMDYgMTEuOTk5Nkg1LjgxOTk3SDEyVjEzLjk5OTZaTTEyIDkuOTk5NThIMy4wMDAwNkMyLjY1MDAxIDkuOTk5NTggMi4zMDk5NiAxMC4wNTk1IDIuMDAwMDMgMTAuMTc5NVY5Ljk5OTU4VjEuOTk5NjNINi45OTk5OVY2Ljk5OTY3TDguOTk5OTUgNS45OTk1NUwxMS4wMDAxIDYuOTk5NjdWMS45OTk2M0gxMlY5Ljk5OTU4WiIgZmlsbD0iIzg2MDkzNSIvPgo8L3N2Zz4K");

;// CONCATENATED MODULE: ./src/modules/Blog/components/Top/components/TextWithIcon.tsx






const TextWithIcon = ({
  withIcon,
  text,
  className
}) => {
  if (withIcon) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(TextWithIcon_Component, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledBookIcon, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Text, {
        className: className,
        children: text
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Text, {
    className: className,
    children: text
  });
};

/* harmony default export */ var components_TextWithIcon = (TextWithIcon);
const TextWithIcon_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TextWithIcon__Component",
  componentId: "sc-lykkts-0"
})(["position:relative;padding-left:26px;"]);
const Text = styled_components_browser_esm["default"].span.withConfig({
  displayName: "TextWithIcon__Text",
  componentId: "sc-lykkts-1"
})(["font-style:normal;font-weight:500;font-size:13px;line-height:30px;"]);
const StyledBookIcon = (0,styled_components_browser_esm["default"])(SvgBook).withConfig({
  displayName: "TextWithIcon__StyledBookIcon",
  componentId: "sc-lykkts-2"
})(["position:absolute;top:50%;transform:translateY(-50%);left:0;"]);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(3570);
// EXTERNAL MODULE: ./src/modules/Blog/components/Top/components/helpers.ts
var helpers = __webpack_require__(40532);
;// CONCATENATED MODULE: ./src/components/BlogNavigation/BlogNavigation.tsx











const BlogNavigation = ({
  categories,
  className,
  title
}) => {
  const router = (0,next_router.useRouter)();
  const stringifiedPath = (0,helpers/* getCurrentAliasPage */.T)(router.asPath);
  const tabToHighlight = (0,helpers/* convertActivePath */.Q)(stringifiedPath);
  const t = (0,production/* useTranslations */.T_)();
  const filteredCategories = (0,react.useMemo)(() => {
    const categoriesWithGlossary = [];

    if (categories.length > 0) {
      categoriesWithGlossary.unshift({
        id: 0,
        language: null,
        name: t('blog.slovar'),
        urlAlias: 'slovar'
      }, ...categories);
      return categoriesWithGlossary;
    }

    return [];
  }, [categories]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BlogNavigation_Component, {
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(DropDown_DropDown, {
      title: title,
      className: "dropdown-component",
      activeTab: tabToHighlight,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(List, {
        children: filteredCategories.map(category => /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
          to: category.name === t('blog.slovar') ? '/blog/slovar' : '/blog/category/' + category.urlAlias,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ListItem, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_TextWithIcon, {
              text: category.name,
              withIcon: category.name === t('blog.slovar'),
              className: `text-element_${tabToHighlight === category.urlAlias ? 'highlighted' : 'hide'}`
            })
          })
        }, category.id))
      })
    })
  });
};

/* harmony default export */ var BlogNavigation_BlogNavigation = (BlogNavigation);
const BlogNavigation_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "BlogNavigation__Component",
  componentId: "sc-li0em4-0"
})(["position:relative;&:before,&:after{position:absolute;content:'';border-top:1px solid ", ";width:100vw;margin-left:calc(50% - 50vw);margin-right:calc(50% - 50vw);}.dropdown-component{padding:5px 0;}"], theme/* colors.grayLighter */.O9.grayLighter);
const List = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "BlogNavigation__List",
  componentId: "sc-li0em4-1"
})([""]);
const ListItem = styled_components_browser_esm["default"].li.withConfig({
  displayName: "BlogNavigation__ListItem",
  componentId: "sc-li0em4-2"
})([""]);
;// CONCATENATED MODULE: ./src/components/BlogNavigation/index.ts

// EXTERNAL MODULE: ./src/components/BreadCrumb/index.ts + 2 modules
var BreadCrumb = __webpack_require__(3601);
;// CONCATENATED MODULE: ./src/components/BlogSharedHeader/components/Top/Title.tsx




const Title_Title = ({
  title
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Title_Component, {
    children: title
  });
};

/* harmony default export */ var Top_Title = (Title_Title);
const Title_Component = styled_components_browser_esm["default"].h1.withConfig({
  displayName: "Title__Component",
  componentId: "sc-nrbfxu-0"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:24px;"]);
;// CONCATENATED MODULE: ./src/components/BlogSharedHeader/components/Top/TopView.tsx







const TopView = ({
  breadCrumbs,
  pageTitle
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TopView_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumb/* default */.Z, {
      breadCrumbs: breadCrumbs
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Top_Title, {
      title: pageTitle
    })]
  });
};

/* harmony default export */ var Top_TopView = (TopView);
const TopView_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TopView__Component",
  componentId: "sc-oh8pw6-0"
})([""]);
;// CONCATENATED MODULE: ./src/components/BlogSharedHeader/components/Top/Top.tsx




const Top_Top = ({
  pageTitle,
  breadCrumbList
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Top_TopView, {
    breadCrumbs: breadCrumbList,
    pageTitle: pageTitle
  });
};

/* harmony default export */ var components_Top_Top = (Top_Top);
;// CONCATENATED MODULE: ./src/components/BlogSharedHeader/components/Top/index.ts

;// CONCATENATED MODULE: ./src/components/BlogSharedHeader/BlogSharedHeader.tsx








const BlogSharedHeader = ({
  categories,
  pageTitle,
  breadCrumbList,
  className
}) => {
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogSharedHeader_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_Top_Top, {
      pageTitle: pageTitle,
      breadCrumbList: breadCrumbList
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BlogNavigation_BlogNavigation, {
      title: t('blog.all_sections'),
      categories: categories,
      className: className
    })]
  });
};

/* harmony default export */ var BlogSharedHeader_BlogSharedHeader = (BlogSharedHeader);
const BlogSharedHeader_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "BlogSharedHeader__Component",
  componentId: "sc-pyp8yj-0"
})([""]);
;// CONCATENATED MODULE: ./src/components/BlogSharedHeader/index.ts


/***/ }),

/***/ 3601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BreadCrumb_BreadCrumb; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/assets/svg/breadcrumb_arrow.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.735073 8.99938C0.924127 8.99938 1.11306 8.9236 1.2568 8.77149L4.78616 5.04303C5.071 4.7426 5.071 4.25676 4.78616 3.95597L1.2568 0.22732C0.970702 -0.07508 0.505042 -0.0767 0.21688 0.22354C-0.0711648 0.523612 -0.0728838 1.01234 0.213334 1.31438L3.22816 4.4994L0.213334 7.68443C-0.0728838 7.98684 -0.0711648 8.4752 0.21688 8.77545C0.360277 8.92486 0.547729 8.99938 0.735073 8.99938Z",
  fill: "#969696"
});

function SvgBreadcrumbArrow({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* harmony default export */ var breadcrumb_arrow = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgNSA5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuNzM1MDczIDguOTk5MzhDMC45MjQxMjcgOC45OTkzOCAxLjExMzA2IDguOTIzNiAxLjI1NjggOC43NzE0OUw0Ljc4NjE2IDUuMDQzMDNDNS4wNzEgNC43NDI2IDUuMDcxIDQuMjU2NzYgNC43ODYxNiAzLjk1NTk3TDEuMjU2OCAwLjIyNzMyQzAuOTcwNzAyIC0wLjA3NTA4IDAuNTA1MDQyIC0wLjA3NjcgMC4yMTY4OCAwLjIyMzU0Qy0wLjA3MTE2NDggMC41MjM2MTIgLTAuMDcyODgzOCAxLjAxMjM0IDAuMjEzMzM0IDEuMzE0MzhMMy4yMjgxNiA0LjQ5OTRMMC4yMTMzMzQgNy42ODQ0M0MtMC4wNzI4ODM4IDcuOTg2ODQgLTAuMDcxMTY0OCA4LjQ3NTIgMC4yMTY4OCA4Ljc3NTQ1QzAuMzYwMjc3IDguOTI0ODYgMC41NDc3MjkgOC45OTkzOCAwLjczNTA3MyA4Ljk5OTM4WiIgZmlsbD0iIzk2OTY5NiIvPgo8L3N2Zz4K");

// EXTERNAL MODULE: ./src/hooks/index.ts + 3 modules
var hooks = __webpack_require__(88619);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(3570);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/BreadCrumb/BreadCrumb.tsx









function BreadCrumb({
  breadCrumbs
}) {
  const siteName = (0,hooks/* useSettingItem */.qT)('WEBSITE_NAME');
  const breadCrumbList = [];

  if (siteName) {
    breadCrumbList.push({
      label: siteName,
      url: '/'
    });
  }

  if (breadCrumbs) {
    breadCrumbList.push(...breadCrumbs);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    children: (breadCrumbList !== null && breadCrumbList !== void 0 ? breadCrumbList : []).map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(Inner, {
      children: [breadCrumbList.length === index + 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
        children: item.label
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        to: item.url,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
          children: item.label
        })
      }), !(breadCrumbList.length === index + 1) && /*#__PURE__*/(0,jsx_runtime.jsx)(SvgBreadcrumbArrow, {})]
    }, index))
  });
}

const Component = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "BreadCrumb__Component",
  componentId: "sc-16duxws-0"
})(["margin-bottom:3px;padding-bottom:3px;white-space:nowrap;overflow:auto;display:flex;align-items:center;margin-top:15px;svg{margin:0 9px;}&::-webkit-scrollbar{-webkit-appearance:none;height:1px;}&::-webkit-scrollbar-thumb{position:absolute;top:0;border-radius:4px;background-color:", ";}"], theme/* colors.grayLighter */.O9.grayLighter);
const Inner = styled_components_browser_esm["default"].li.withConfig({
  displayName: "BreadCrumb__Inner",
  componentId: "sc-16duxws-1"
})(["display:flex;align-items:center;"]);
const Label = styled_components_browser_esm["default"].div.withConfig({
  displayName: "BreadCrumb__Label",
  componentId: "sc-16duxws-2"
})(["font-style:normal;font-weight:500;font-size:10px;line-height:18px;color:#7e7e7e;"]);
/* harmony default export */ var BreadCrumb_BreadCrumb = (BreadCrumb);
;// CONCATENATED MODULE: ./src/components/BreadCrumb/index.ts


/***/ }),

/***/ 89875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Pagination_Pagination; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/rc-pagination/es/index.js + 18 modules
var es = __webpack_require__(66455);
// EXTERNAL MODULE: ./node_modules/@tager/web-core/dist/web-core.esm.js + 6 modules
var web_core_esm = __webpack_require__(61055);
;// CONCATENATED MODULE: ./src/assets/svg/NextArrow.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.39999 8.8999L1.19999 15.1999C0.799988 15.5999 0.799988 16.1999 1.19999 16.5999C1.59999 16.9999 2.19999 16.9999 2.59999 16.5999L9.49999 9.5999C9.89999 9.1999 9.89999 8.5999 9.49999 8.1999L2.59999 1.1999C2.39999 0.999902 2.19999 0.899902 1.89999 0.899902C1.59999 0.899901 1.39999 0.999902 1.19999 1.1999C0.799989 1.5999 0.799989 2.1999 1.19999 2.5999L7.39999 8.8999Z",
  fill: "black"
});

function SvgNextArrow({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* harmony default export */ var NextArrow = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxMCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjM5OTk5IDguODk5OUwxLjE5OTk5IDE1LjE5OTlDMC43OTk5ODggMTUuNTk5OSAwLjc5OTk4OCAxNi4xOTk5IDEuMTk5OTkgMTYuNTk5OUMxLjU5OTk5IDE2Ljk5OTkgMi4xOTk5OSAxNi45OTk5IDIuNTk5OTkgMTYuNTk5OUw5LjQ5OTk5IDkuNTk5OUM5Ljg5OTk5IDkuMTk5OSA5Ljg5OTk5IDguNTk5OSA5LjQ5OTk5IDguMTk5OUwyLjU5OTk5IDEuMTk5OUMyLjM5OTk5IDAuOTk5OTAyIDIuMTk5OTkgMC44OTk5MDIgMS44OTk5OSAwLjg5OTkwMkMxLjU5OTk5IDAuODk5OTAxIDEuMzk5OTkgMC45OTk5MDIgMS4xOTk5OSAxLjE5OTlDMC43OTk5ODkgMS41OTk5IDAuNzk5OTg5IDIuMTk5OSAxLjE5OTk5IDIuNTk5OUw3LjM5OTk5IDguODk5OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=");

// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Pagination/Pagination.tsx








function Pagination({
  onChange,
  count,
  pageSize,
  current,
  className
}) {
  const {
    0: offSetTop,
    1: setOffsetTop
  } = (0,react.useState)(0);
  const {
    0: offSetTopClient,
    1: setOffsetTopClient
  } = (0,react.useState)(0);
  const ref = (0,react.useRef)(null);

  const onPageChange = page => {
    if (ref.current) {
      setOffsetTop(ref.current.offsetTop);
      setOffsetTopClient(ref.current.getBoundingClientRect().top);
    }

    onChange(page);
  };

  (0,react.useEffect)(() => {
    const domNode = ref.current;

    if (!domNode) {
      return;
    }

    if (offSetTop === 0) {
      return;
    }

    const nodeOffsetTopCurrent = domNode.offsetTop;

    if (nodeOffsetTopCurrent !== offSetTop) {
      (0,web_core_esm.isBrowser)() && window.scroll({
        top: domNode.offsetTop - (domNode.getBoundingClientRect().height + offSetTopClient - 40)
      });
    }
  });
  (0,react.useEffect)(() => {
    if (ref.current) {
      var _ref$current$querySel, _ref$current$querySel2;

      (_ref$current$querySel = ref.current.querySelector('.rc-pagination-next')) === null || _ref$current$querySel === void 0 ? void 0 : _ref$current$querySel.setAttribute('title', '');
      (_ref$current$querySel2 = ref.current.querySelector('.rc-pagination-prev')) === null || _ref$current$querySel2 === void 0 ? void 0 : _ref$current$querySel2.setAttribute('title', '');
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(es/* default */.Z, {
      className: "pagination",
      nextIcon: true,
      current: current,
      hideOnSinglePage: true,
      pageSize: pageSize,
      onChange: onPageChange,
      showSizeChanger: false,
      total: count,
      showLessItems: true
    })
  });
}

/* harmony default export */ var Pagination_Pagination = (Pagination);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Pagination__Component",
  componentId: "sc-1onxtng-0"
})(["padding:5px 0;.rc-pagination{display:flex;align-items:center;justify-content:center;& > li:not(:first-child){margin-left:10px;}}.rc-pagination-prev,.rc-pagination-next,.rc-pagination-item{position:relative;cursor:pointer;width:30px;height:30px;display:flex;align-items:center;justify-content:center;border-radius:5px;border:1px solid ", ";}.rc-pagination-prev:after{content:url(", ");position:absolute;left:calc(50% + 1px);top:calc(50% - 1px);transform:translate(-50%,-50%) rotate(180deg);}.rc-pagination-next:after{content:url(", ");position:absolute;left:50%;top:calc(50% + 1px);transform:translate(-50%,-50%);}.rc-pagination-item{color:", ";border-radius:5px;}.rc-pagination-disabled{border:1px solid ", ";}.rc-pagination-item-active{background:", ";color:", ";}.rc-pagination-jump-prev,.rc-pagination-jump-next{display:none;}"], theme/* colors.gray70 */.O9.gray70, NextArrow, NextArrow, theme/* colors.black */.O9.black, theme/* colors.gray100 */.O9.gray100, theme/* colors.primary */.O9.primary, theme/* colors.white */.O9.white);
;// CONCATENATED MODULE: ./src/components/Pagination/index.ts


/***/ }),

/***/ 40532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ getCurrentAliasPage; },
/* harmony export */   "Q": function() { return /* binding */ convertActivePath; }
/* harmony export */ });
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29116);

const getCurrentAliasPage = path => {
  return (0,_utils_common__WEBPACK_IMPORTED_MODULE_0__/* .getAliasString */ .Jz)(path).split('/').slice(-1).join('');
};
const convertActivePath = path => {
  return path === 'blog' ? '' : path.split('/').slice(-1).join('');
};

/***/ }),

/***/ 35635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _sentry_node__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24403);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12918);
/* harmony import */ var _tager_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63394);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






function ErrorPage({
  statusCode,
  title,
  isInitProps,
  errorId,
  err
}) {
  if (!isInitProps && !errorId && err) {
    // getInitialProps is not called in case of
    // https://github.com/zeit/next.js/issues/8592. As a workaround, we pass
    // err via _app.js so it can be captured
    errorId = _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err);
  }

  const errorCode = statusCode !== null && statusCode !== void 0 ? statusCode : 500;
  const errorName = err !== null && err !== void 0 && err.name ? err.name.replace(/\.$/, '') : title !== null && title !== void 0 ? title : 'JavaScript Error';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tager_web_components__WEBPACK_IMPORTED_MODULE_2__/* .Page */ .T3, {
    title: "An error occurred",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tager_web_components__WEBPACK_IMPORTED_MODULE_2__/* .ErrorModule */ .TW, {
      errorCode: errorCode,
      errorName: errorName,
      errorId: errorId
    })
  });
}

ErrorPage.getInitialProps = async pageContext => {
  const {
    res,
    err,
    asPath
  } = pageContext;
  const errorInitialProps = await next_error__WEBPACK_IMPORTED_MODULE_1__["default"].getInitialProps(pageContext); // Workaround for https://github.com/zeit/next.js/issues/8592, mark when
  // getInitialProps has run

  errorInitialProps.isInitProps = true;

  if (res) {
    // Running on the server, the response object is available.
    //
    // Next.js will pass an err on the server if a page's `getInitialProps`
    // threw or returned a Promise that rejected
    if (res.statusCode === 404) {
      // Opinionated: do not record an exception in Sentry for 404
      return {
        statusCode: 404
      };
    }

    if (err) {
      errorInitialProps.errorId = _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err);
      return errorInitialProps;
    }
  } else {
    // Running on the client (browser).
    //
    // Next.js will provide an err if:
    //
    //  - a page's `getInitialProps` threw or returned a Promise that rejected
    //  - an exception was thrown somewhere in the React lifecycle (render,
    //    componentDidMount, etc) that was caught by Next.js's React Error
    //    Boundary. Read more about what types of exceptions are caught by Error
    //    Boundaries: https://reactjs.org/docs/error-boundaries.html
    if (err) {
      errorInitialProps.errorId = _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err);
      return errorInitialProps;
    }
  } // If this point is reached, getInitialProps was called without any
  // information about what the error might be. This is unexpected and may
  // indicate a bug introduced in Next.js, so record it in Sentry


  errorInitialProps.errorId = _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(new Error(`_error.js getInitialProps missing data at path: ${asPath}`));
  return errorInitialProps;
};

/* harmony default export */ __webpack_exports__["default"] = (ErrorPage);

/***/ }),

/***/ 26625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ getSharedThunkList; }
/* harmony export */ });
/* harmony import */ var _store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67463);
/* harmony import */ var _store_reducers_tager_settings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35439);
/* harmony import */ var _store_reducers_pages_products__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13006);
/* harmony import */ var _store_reducers_tager_blog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44272);




function getSharedThunkList(dispatch) {
  return [dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getMenuItemListThunk */ .up)('top')), dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getMenuItemListThunk */ .up)('main')), dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getMenuItemListThunk */ .up)('footer')), dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getMenuItemListThunk */ .up)('catalog')), dispatch((0,_store_reducers_pages_products__WEBPACK_IMPORTED_MODULE_2__/* .getProductListByGroupThunk */ .fd)('TOP')), dispatch((0,_store_reducers_pages_products__WEBPACK_IMPORTED_MODULE_2__/* .getProductListByGroupThunk */ .fd)('NEW')), dispatch((0,_store_reducers_tager_settings__WEBPACK_IMPORTED_MODULE_1__/* .getSettingItemListThunk */ .rT)()), dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getCatalogMenuThunk */ .ke)()), dispatch((0,_store_reducers_tager_blog__WEBPACK_IMPORTED_MODULE_3__/* .getBlogPostListThunk */ .R3)())];
}

/***/ })

}]);